import request from '@/api/request' // 确保路径正确，指向你的 request.js

export default {
    getPage(data) {
        return request({
            url: '/shop/page',
            method: 'get',
            params: data
        })
    },
    createShop(data) {
        return request({
            url: '/shop/createShop',
            method: 'post',
            data
        })
    },

    getShops(data) {
        return request({
            url: '/decoration/shopsByOrganization',
            method: 'get',
            params: data
        })
    },
}